// @flow strict

//$FlowFixMe[nonstrict-import]
import type {State} from 'src/reducers';
import type {DateRangeWithTimezone} from '@spaced-out/ui-design-system/lib/types';
import type {
  HiringPipelineFilters,
  SavedDashboardList,
  SelectedInterviewFilterColumnsData,
  SelectedJobStatusFilterColumnsData,
  SelectedPipelineVelocityFilterColumnsData,
  SelectedPipelineVelocityDrilldownFilterColumnsData,
} from 'src/types/analytics-genesis';


export const selectJobFilters = (state: State): HiringPipelineFilters =>
  state.analyticsHiringPipeline.selectedJobFilters;

export const selectDashboardID = (state: State): ?string =>
  state.analyticsHiringPipeline.currentDashboardID;

export const selectDateRange = (state: State): DateRangeWithTimezone =>
  state.analyticsHiringPipeline.selectedDateRange;

export const selectSavedDashboards = (state: State): SavedDashboardList =>
  state.analyticsHiringPipeline.savedDashboards;

export const selectJobStatusTableColumnFilterData = (
  state: State,
): SelectedJobStatusFilterColumnsData =>
  state.analyticsHiringPipeline.jobStatusAgeTableColumnFilter ?? {};

export const selectInterviewScheduleTableColumnFilterData = (
  state: State,
): SelectedInterviewFilterColumnsData =>
  state.analyticsHiringPipeline.interviewScheduleTableColumnFilter ?? {};

export const selectPipelineVelocityTableColumnFilterData = (
  state: State,
): SelectedPipelineVelocityFilterColumnsData =>
  state.analyticsHiringPipeline.pipelineVelocityTableColumnFilter ?? {};

export const selectPipelineVelocityDrilldownTableColumnFilterData = (
  state: State,
): SelectedPipelineVelocityDrilldownFilterColumnsData =>
  state.analyticsHiringPipeline.pipelineVelocityDrilldownTableColumnFilter ??
  {};
